import CurrencyRateAPI from '../../../api/CurrencyRate';

export default {
  async getCurrencyRate({commit}, data) {
    if(data.type === 'CBR') {
      return await new CurrencyRateAPI().getCurrencyRateCBR(data);
    } else if (data.type === 'Corridor') {
      return await new CurrencyRateAPI().getCurrencyRateCorridor(data);
    } else if (data.type === 'Corridor_Imported') {
      return await new CurrencyRateAPI().getCurrencyRateCorridorImported(data);
    } else if (data.type === 'Fixed') {
      return await new CurrencyRateAPI().getCurrencyRateFixed(data);
    } else if (data.type === 'Imported') {
      return await new CurrencyRateAPI().getCurrencyRateImported(data);
    }
  },

  async getCurrencyRateFromCBR({
    commit
  }, data) {
    return await new CurrencyRateAPI().getCurrencyRateFromCBR(data.date, data.currencyCode);
  },

  async getCurrencyRateFromImport({
    commit
  }, data) {
    return await new CurrencyRateAPI().getCurrencyRateFromImport(data.date, data.currencyCode, data.importedId);
  },

  async currencyRateImport({commit}, data) {
    return await new CurrencyRateAPI().excelImport(data);
  },
};
